/**
 * A function for determining if the image should fill the parent container or not.
 */ const shouldFillParentContainer = (props)=>!props.width && !props.height;

export { shouldFillParentContainer };
